module.exports = __webpack_public_path__ + "img/logo_dark.39addb99.png";